import React from "react";
import { Smartphone } from "lucide-react";
import { cn } from "@/lib/utils";
import { MemberAvailability } from "@/model/interface/Membership";

export default function MemberAvailabilityStatus({ availability }: { availability?: MemberAvailability }) {
  if (availability === "ON_CALL") {
    return (
      <span className="status-pill-warning shrink-0">
        <span className="h-1.5 w-1.5 rounded-full bg-warning" />
        On a call
      </span>
    );
  }
  if (availability === "MOBILE") {
    return (
      <span className="inline-flex shrink-0 items-center gap-1.5 text-xs font-bold text-info">
        <Smartphone className="h-3 w-3" />
        Mobile
      </span>
    );
  }
  if (availability === "UNAVAILABLE") {
    return (
      <span className="status-pill-destructive shrink-0">
        <span className="h-1.5 w-1.5 rounded-full bg-destructive" />
        Unavailable
      </span>
    );
  }
  const isAvailable = availability === "AVAILABLE";
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center gap-1.5 text-xs font-bold",
        isAvailable ? "text-success" : "text-muted-foreground",
      )}
    >
      <span className={cn("h-2 w-2 rounded-full", isAvailable ? "bg-success" : "bg-muted-foreground/50")} />
      {isAvailable ? "Available" : "Offline"}
    </span>
  );
}
